import { types } from "../types/types";
import { startAlerta } from "./ui/alertas";
import MedicosService from "../services/MedicosService";
import { finishSpinner, startSpinner } from "./ui/spinner";
import { handleErrorApi } from "../helpers/randoms";
import { fetchConToken } from "../helpers/fetch";

export const fetchEspecialidadesProfesional = (idEfectorRed) => async (dispatch) => {
  dispatch({ type: types.especialidadesProfesionalTraer })
  try {
      const result= await MedicosService.especialidadesEfectorP(idEfectorRed)

      const body = await result.json()
      if (result.ok) {
          dispatch({
              type: types.especialidadesProfesionalTraerSucces,
              payload: body
          })
      } else {
          throw body.errores
      }

  } catch (error) {
      dispatch({ type: types.especialidadesProfesionalTraerError })
      console.log("Error al traer las especialidades del medico", error)
      if (error.mensaje) {
          dispatch(startAlerta(error.mensaje, "error"))
      } else {
          dispatch(startAlerta("Ha ocurrido un error. Intente nuevamente.", "error"))
      }
  }
}

export const fetchCentrosProfesional = (idEfectorRed) => async (dispatch) => {
    dispatch({ type: types.centrosPropiosProfesionalTraer })
    try {
        const result= await MedicosService.cmEfectorP(idEfectorRed)
  
        const body = await result.json()
        if (result.ok) {
            dispatch({
                type: types.centrosPropiosProfesionalTraerSucces,
                payload: body
            })
        } else {
            throw body.errores
        }
  
    } catch (error) {
        dispatch({ type: types.centrosPropiosProfesionalTraerError })
        console.log("Error al traer los centros del medico", error)
        if (error.mensaje) {
            dispatch(startAlerta(error.mensaje, "error"))
        } else {
            dispatch(startAlerta("Ha ocurrido un error. Intente nuevamente.", "error"))
        }
    }
  }

  export const setMedicoCM = (idEfectorRed, idItem, setOrDelete) => async (dispatch, getState) => {
    dispatch({ type: types.setOrDeleteCMProfesional })
    try {
        let result;
        if(setOrDelete){
            result=await MedicosService.setCM({idEfectorRed:idEfectorRed, idCentroMedico:idItem})
        }else{
            result=await MedicosService.deleteCM({idEfectorRed:idEfectorRed, idCentroMedico:idItem})
        }
  
        const body = await result.json()
        if (result.ok) {
            let data;
            const centros=getState().medico.profesionalCentros
            if(setOrDelete){
               data=[...centros, {idEfectorRed:idEfectorRed, idCentromedico:idItem}]
            }else{
                data=centros.filter(e=>parseInt(e.idCentromedico) !== parseInt(idItem))
            }

            dispatch({
                type: types.setOrDeleteCMProfesionalSuccess,
                payload: data
            })
        } else {
            throw body.errores
        }
  
    } catch (error) {
        dispatch({ type: types.setOrDeleteCMProfesionalError })
        console.log("Error al eliminar el centro del medico", error)
        if (error.mensaje) {
            dispatch(startAlerta(error.mensaje, "error"))
        } else {
            dispatch(startAlerta("Ha ocurrido un error. Intente nuevamente.", "error"))
        }
    }
  }

  export const setMedicoEspecialidad= (idEfectorRed, idItem, setOrDelete) => async (dispatch, getState) => {
    dispatch({ type: types.setOrDeleteEspecialidadProfesional })
    try {
        let result;
        if(setOrDelete){
            result=await MedicosService.setEspecialidad({idEfectorRed:idEfectorRed, idEspecialidad:idItem})
        }else{
            result=await MedicosService.deleteEspecialidad({idEfectorRed:idEfectorRed, idEspecialidad:idItem})
        }
  
        const body = await result.json()
        if (result.ok) {
            let data;
            const especialidades=getState().medico.profesionalEspecialidades
            if(setOrDelete){
               data=[...especialidades, {idEfectorRed:idEfectorRed, idEspecialidad:idItem}]
            }else{
                data=especialidades.filter(e=>parseInt(e.idEspecialidad) !== parseInt(idItem))
            }

            dispatch({
                type: types.setOrDeleteEspecialidadProfesionalSuccess,
                payload: data
            })
        } else {
            throw body.errores
        }
  
    } catch (error) {
        dispatch({ type: types.setOrDeleteEspecialidadProfesionalError })
        console.log("Error al eliminar la especialidad del medico", error)
        if (error.mensaje) {
            dispatch(startAlerta(error.mensaje, "error"))
        } else {
            dispatch(startAlerta("Ha ocurrido un error. Intente nuevamente.", "error"))
        }
    }
  }

  export const agregarRelacionEspecialidades = (id, idEspecialidad) => async (dispatch) => {
    try {
       dispatch(startSpinner());
       const data = {
           idEfectorRed : id,
           idEspecialidad: idEspecialidad
       }
       const response = await fetchConToken(`RelacionesEspecialidades`, data, "POST");
       const body = await response.json();
       if (response.ok) {
           dispatch(startAlerta("Relacion creado correctamente", 'success', 'Comando Exitoso'));
           dispatch(finishSpinner());
           
       } else {
           throw body;
       }
   } catch (error) {
       dispatch(finishSpinner());
       handleErrorApi(dispatch, error, "Error al crear la Relacion.", "Ha ocurrido un error. Intente nuevamente")
   }
};

export const agregarRelacionCentrosMedicos = (id, idCentrosMedicos) => async (dispatch) => {
    try {
       dispatch(startSpinner());
       const data = {
           idEfectorRed : id,
           id_CentroMedico: idCentrosMedicos
       }
       const response = await fetchConToken(`RelacionesCentrosMedicos`, data, "POST");
       const body = await response.json();
       if (response.ok) {
           dispatch(startAlerta("Relacion creado correctamente", 'success', 'Comando Exitoso'));
           dispatch(finishSpinner());
           
       } else {
           throw body;
       }
   } catch (error) {
       dispatch(finishSpinner());
       handleErrorApi(dispatch, error, "Error al crear la Relacion.", "Ha ocurrido un error. Intente nuevamente")
   }
};
